// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/dna.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* header */
.header-container {
  padding: 25px 0px;
}

.header-container::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150px;
  background: linear-gradient(to right, rgba(30, 67, 86, 0.8), rgba(30, 67, 86, 0.6)), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center top no-repeat;
  z-index: -1;
  background-size: cover;
}
  
.header {
  color: white;
  max-width: 90%;
  margin: 0 auto;
}
  
.header h1 {
  font-size: 2em;
  margin: 0;
  letter-spacing: 1.2px;
}
  
  
  /* search box area */
.controls {
  /* border: 2px solid #ccc; */
  border-radius: 5px;
  max-width: 90%;
  margin: 15px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 50px ;
}
  
#total {
  color: #031634;
  font-size: xx-large;
  font-weight: bold;
}
  
#item-count {
  color: black;
  font-size: x-large;
}
  
.search-field {
  display: flex;
  gap: 10px;
  align-items: center;
}
  
.search-download-column input {
  font-size: 17px;
  padding: 10px;
  width: 500px;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 4px;
  letter-spacing: 0.5px;
}
  
.search-download-column button {
  margin: 0;
  height: 50px;
  padding: 0px 25px;
  font-size: 17px;
  color: white;
  background-color: #3a89c9;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  letter-spacing: 1.2px;
}

.search-download-column button:hover {
  background-color: #0056b3;
}

.download-link {
  padding: 5px 2px;
}
  
.download-link a {
  font-size: 14px;
  color: #3a89c9;
  text-decoration: none;
  font-weight: bold;
}


/* table */
.general-table-container {
  margin: 20px auto;
  max-width: 90vw;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 50px;
  }

table {
  border-collapse: collapse;
  table-layout: auto;
  min-width: 90vw;
}

th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  word-wrap: break-word;
  max-width: 300px;
}

.general-table-container th {
  cursor: pointer;
}

thead {
  background-color: #3a89c9;
  color: white;
  vertical-align: top;
  border-bottom: 1px solid #ddd;
}

.col-checkbox {
  width: 50px;
}

input[type="checkbox"] {
  cursor: pointer;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.col-checkbox {
  width: 3%;
}

#gRNA_scaffold {
  width: 12%;
}

#gRNA_scaffold_sequence {
  width: 50%;
}

#polyT_length {
  width: 15%;
}

#gRNA_scaffold_sequence_length {
  width: 20%;
}

.general-table-container a {
  color: #007bff;
  text-decoration: none;
}

.general-table-container a:hover {
  color: #0056b3;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/pages/Scaffold.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,iJAAgI;EAChI,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,qBAAqB;AACvB;;;EAGE,oBAAoB;AACtB;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;;AAGA,UAAU;AACV;EACE,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB;;AAEF;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B","sourcesContent":["/* header */\n.header-container {\n  padding: 25px 0px;\n}\n\n.header-container::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 150px;\n  background: linear-gradient(to right, rgba(30, 67, 86, 0.8), rgba(30, 67, 86, 0.6)), url(../assets/dna.jpg) center top no-repeat;\n  z-index: -1;\n  background-size: cover;\n}\n  \n.header {\n  color: white;\n  max-width: 90%;\n  margin: 0 auto;\n}\n  \n.header h1 {\n  font-size: 2em;\n  margin: 0;\n  letter-spacing: 1.2px;\n}\n  \n  \n  /* search box area */\n.controls {\n  /* border: 2px solid #ccc; */\n  border-radius: 5px;\n  max-width: 90%;\n  margin: 15px auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 50px ;\n}\n  \n#total {\n  color: #031634;\n  font-size: xx-large;\n  font-weight: bold;\n}\n  \n#item-count {\n  color: black;\n  font-size: x-large;\n}\n  \n.search-field {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n  \n.search-download-column input {\n  font-size: 17px;\n  padding: 10px;\n  width: 500px;\n  height: 30px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  letter-spacing: 0.5px;\n}\n  \n.search-download-column button {\n  margin: 0;\n  height: 50px;\n  padding: 0px 25px;\n  font-size: 17px;\n  color: white;\n  background-color: #3a89c9;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  letter-spacing: 1.2px;\n}\n\n.search-download-column button:hover {\n  background-color: #0056b3;\n}\n\n.download-link {\n  padding: 5px 2px;\n}\n  \n.download-link a {\n  font-size: 14px;\n  color: #3a89c9;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n\n/* table */\n.general-table-container {\n  margin: 20px auto;\n  max-width: 90vw;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 50px;\n  }\n\ntable {\n  border-collapse: collapse;\n  table-layout: auto;\n  min-width: 90vw;\n}\n\nth, td {\n  padding: 10px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n  word-wrap: break-word;\n  max-width: 300px;\n}\n\n.general-table-container th {\n  cursor: pointer;\n}\n\nthead {\n  background-color: #3a89c9;\n  color: white;\n  vertical-align: top;\n  border-bottom: 1px solid #ddd;\n}\n\n.col-checkbox {\n  width: 50px;\n}\n\ninput[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\ntr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.col-checkbox {\n  width: 3%;\n}\n\n#gRNA_scaffold {\n  width: 12%;\n}\n\n#gRNA_scaffold_sequence {\n  width: 50%;\n}\n\n#polyT_length {\n  width: 15%;\n}\n\n#gRNA_scaffold_sequence_length {\n  width: 20%;\n}\n\n.general-table-container a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.general-table-container a:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
